import React, { useEffect } from "react";
import EngineeringImg from '../Images/Engineering.jpg';
import UrlTag from "../components/UrlTag";
import { Link } from "react-router-dom";

function Engineering() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="z-20">
            <UrlTag />
            <div className="relative">
                <img src={EngineeringImg} alt="Engineering" className="w-full h-[300px] md:h-[500px] object-cover" />
                <div className="absolute inset-0 bg-black opacity-40"></div>
                <div className="absolute bottom-0 left-0 py-4 md:py-8 px-4 md:px-14">
                    <h1 className="text-white text-2xl md:text-4xl font-bold">Engineering</h1>
                </div>
            </div>
            <div className="p-4 md:p-16 max-w-[620px] mx-auto">
                <div className="mb-10">
                    <h1 className="text-xl md:text-2xl mb-4 tracking-wider">
                        Engineering at Architetive Designs
                    </h1>
                    <p className="text-base md:text-lg mb-6 tracking-wider text-gray-700 font-light">
                        An integrated design approach generates more innovative and sustainable outcomes. To build sustainably requires us to design holistically, where engineering is integrated from the outset of the design process. The practice has two in-house engineering groups, with a focus on environmental and structural engineering. Working alongside design teams in an open, collaborative environment, the groups strengthen the studio’s environmental agenda, capabilities and commitment to integrated design.
                    </p>
                </div>
                <div className="flex flex-row gap-4">
                    <Link to='/contact'>
                        <button className="text-gray-500 bg-[#eeeeee] hover:bg-[#e6e6e6] rounded-full px-4 py-1">Contact</button>
                    </Link>
                    <Link to='/careers/vacancies'>
                        <button className="text-gray-500 bg-[#eeeeee] hover:bg-[#e6e6e6] rounded-full px-4 py-1">Vacancies</button>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default Engineering;